<template>
    <div v-if="loading()"></div>
    <MainLayout v-else-if="hasAccessToTests()" marginTop>
        <AssessmentModule slot="center" :tests="tests" />

        <ProfileModule slot="right" />

        <FeaturedResource slot="right" />
    </MainLayout>
    <div v-else>
        <!-- Display error or unauthorized message -->
        <img
            :src="isError ? warningSvg : emptySvg"
            style="display:block;margin:auto;width:200px;height:200px;object-fit:scale-down;margin-top:40px;"
        />
        <h6 class="text-center mb-0">
            {{ isError ? $t('tests.error') : $t('tests.unauthorized') }}
        </h6>
    </div>
</template>

<script>
// Page components
import MainLayout from '~/components/layouts/mainlayout/MainLayout';
import AssessmentModule from './components/AssessmentModule';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule';
import FeaturedResource from '~/components/smart/FeaturedResource';

// Assets
import EmptySvg from '~/assets/img/empty.svg';
import CuteSvg from '~/assets/img/cut-e.svg';
import WarningSvg from '~/assets/img/warning.svg';

export default {
    name: 'TestsDashboard',
    components: {
        MainLayout,
        AssessmentModule,
        ProfileModule,
        FeaturedResource,
    },
    data: () => ({
        emptySvg: EmptySvg,
        warningSvg: WarningSvg,
    }),
    computed: {
        testData() {
            return this.$interfaces.candidate.test.get({
                reactive: true,
            });
        },
        tests() {
            return [
                {
                    key: 'cut-e',
                    img: CuteSvg,
                    title: this.$t('tests.tests.cute.title'),
                    description: this.$t('tests.tests.cute.description'),
                    actionLabel: this.$t('tests.tests.cute.action'),
                    url: this.$URLS.cute,
                },
                /* {
                    programming: 'programming',
                    img: 'https://image.flaticon.com/icons/svg/69/69084.svg',
                    title: this.$t('tests.tests.programming.title'),
                    comingSoon: true,
                }, */
            ];
        },
        isError() {
            return Boolean(this.error());
        },
    },
    methods: {
        loading() {
            return this.testData.loading;
        },
        error() {
            return this.testData.error;
        },
        hasAccessToTests() {
            return this.testData && this.testData.data;
        },
    },
};
</script>

<style lang="scss" scoped></style>
